import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import AutoComplete from './AutoComplete';

import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import Checkbox from 'material-ui/Checkbox';
import DropDownMenu from 'material-ui/DropDownMenu';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import InfoOutline from 'material-ui-icons/InfoOutline';
import * as _ from 'lodash';
import qs from 'qs';
import classNames from 'classnames';

import MaskedTextField from './MaskedTextField';

import { RegistrationService } from '../registration.service';
import { errorStyle, textStyle, underlineStyle } from '../styles';
import { ValidationService } from '../validation.service';

class RegistrationStep3 extends Component {
  constructor(props) {
    super(props);
    this.props.state.benefitProviderSearch = undefined;
    this.props.state.eligibilityBusinessUnitData = undefined;
    this.props.state.insuranceLabel = undefined;

    this.throttledBenefitProviderSearch = _.throttle(
      this.benefitProviderSearch,
      1000,
      {
        leading: false,
        trailing: true,
      }
    );

    this.registrationService = new RegistrationService();
    this.validationService = new ValidationService(this.props.intl);

    this.state = {
      isLoading: false,
      showPrimary: false,
      eligibilityError: this.props.state.eligibilityError || false,
      eligibilityErrorText: '',
      eligibilityErrorReason: '',
      autocompleteDataSource: [],
      checkEligibilityRespData: [],
      isSearchTooltipVisible: false,
      isTooltipVisible: false,
      tooltipImage: null,
      insuranceLabel: null,
      selectableAffiliations: CHILD_AFFILIATIONS || [],
      childSelected: false,
      affRadioDisabled: false,
      eligibilityRetries: 1,
      affRadioSelected: false,
    };
  }

  async componentDidMount() {
    if (_.size(AFFILIATION_ID)) {
      let oneChild =
        _.get(this.props.state, 'hasAffiliatedBenefit', '') == 1 &&
        _.size(CHILD_AFFILIATIONS) == 1;
      let query = oneChild ? CHILD_AFFILIATIONS[0][0] : AFFILIATION_ID;

      this.props.onChange({
        isLoading: true,
        benefitProviderSearch: oneChild
          ? CHILD_AFFILIATIONS[0][1]
          : AFFILIATION,
      });

      if (oneChild) {
        this.setState({ childSelected: true });
      }
      let autocompleteDataSource = await this.benefitProviderSearch(
        query,
        true
      );
      this.onNewRequestBenefitProviderSearch(autocompleteDataSource[0].value);
    }

    setTimeout(() => {
      $('svg').attr('focusable', false);
    }, 500);
  }

  onChangeBenefitProviderSearch(query) {
    this.setState({ isSearchTooltipVisible: false });
    this.props.onChange({
      isLoading: true,
      benefitProviderSearch: _.trim(query),
      eligibilityBusinessUnitData: undefined,
      eligibilityInsurancePlan: undefined,
    });

    return this.throttledBenefitProviderSearch(_.trim(query));
  }

  async benefitProviderSearch(query, withId) {
    let autocompleteDataSource = this.state.autocompleteDataSource;

    if (query.length > 2 || withId) {
      this.props.onChange({ isLoading: true });
      let autocompleteResp = await this.registrationService.affiliationList(
        query,
        withId
      );
      autocompleteDataSource = autocompleteResp.parsed.data.affiliations.map(
        affiliation => {
          return {
            text: affiliation[1],
            value: affiliation[0],
          };
        }
      );

      autocompleteDataSource.sort(function(a, b) {
        if (a.text < b.text) {
          return -1;
        }
        if (a.text > b.text) {
          return 1;
        }
        return 0;
      });

    } else if (!query.length) {
      autocompleteDataSource = [];
    }

    this.setState({
      autocompleteDataSource,
    });
    this.props.onChange({ isLoading: false });
    return Promise.resolve(autocompleteDataSource);
  }

  async onNewRequestBenefitProviderSearch(value) {
    let searchResp = await this.registrationService.affiliationEligibilityDetailsSearch(
      value
    );
    if (value) {
      this.props.onChange({
        eligibilityBusinessUnitData: searchResp.parsed.data,
        eligibilityBusinessUnit: null,
        tooltipImage: searchResp.parsed.data.tooltip_image,
        insuranceLabel: searchResp.parsed.data.insurance_label,
      });
    }
  }

  onBenefitProviderSelect(value) {
    const { autocompleteDataSource } = this.state;
    const selectedItem = autocompleteDataSource.find(
      data => data.text == value
    );

    this.onNewRequestBenefitProviderSearch(selectedItem.value);
  }

  pollCheckEligibilityStatus(token) {
    return this.registrationService.checkEligibilityStatus(token).then(resp => {
      let checkEligibilityRespData = resp.parsed.data;
      if (
        _.get(
          checkEligibilityRespData,
          'eligibility_check.completed',
          false
        ) === true
      ) {
        this.setState({ isLoading: false });
        return this.signup(checkEligibilityRespData);
      } else {
        setTimeout(() => this.pollCheckEligibilityStatus(token), 2000);
      }
    });
  }

  signup(checkEligibilityRespData) {
    var eligibilityCheckEligible = _.get(
      checkEligibilityRespData,
      'eligibility_check.eligible',
      null
    );
    var eligible = null;

    if (eligibilityCheckEligible != null) {
      eligible = eligibilityCheckEligible;
    } else {
      eligible = _.get(checkEligibilityRespData, 'eligible', null);
    }

    if (eligible === true) {
      this.setState({ isLoading: true });
      let userProvidedPatientData = this.props.state;

      if (this.is270Affiliation()) {
        userProvidedPatientData.eligibility_check_token =
          checkEligibilityRespData.eligibility_check.token;
        let eligibleAffiliation = _.get(
          checkEligibilityRespData,
          'eligibility_check.affiliation_id',
          null
        );
        if (!_.isNull(eligibleAffiliation)) {
          userProvidedPatientData.eligibilityBusinessUnitData.affiliation_id = eligibleAffiliation;
        }
      } else {
        userProvidedPatientData.memberID =
          checkEligibilityRespData.eligibility_check.member_id;
      }

      let patient = this.registrationService.getPatientCreateObject(
        userProvidedPatientData
      );

      return this.registrationService
        .register({ patient })
        .then(resp => {
          this.setState({ isLoading: false });

          this.registrationService.sendUtmReferral(resp.parsed.data.patient.id);
          this.props.onChange({
            signupRespData: resp.parsed.data,
          });
          this.props.goToStep(4);
        })
        .catch(() => {
          this.setState({ isLoading: false });
        });
    } else if (eligible === false) {
      //270 or CSV returns errors on eligibility_check response
      if (this.state.eligibilityRetries > 0) {
        let remainingTries = this.state.eligibilityRetries - 1;
        this.setState({ eligibilityRetries: remainingTries });
        return this.submit();
      }

      if (
        _.get(checkEligibilityRespData, 'eligibility_check.group_list', [])
          .length > 0
      ) {
        this.setState({
          selectableAffiliations: _.get(
            checkEligibilityRespData,
            'eligibility_check.group_list',
            null
          ),
        });
      }

      if (this.state.continueRegistration === true) {
        let patient = this.registrationService.getPatientCreateObject(
          this.props.state
        );
        this.registrationService
          .register({
            patient: {
              ...patient,
              skip_eligibility_check: {
                member_id: this.props.state.memberID270,
                dependent: !!this.props.state.isDependent,
                primary_attributes: {
                  first_name: this.props.state.primaryFirstName,
                  last_name: this.props.state.primaryLastName,
                  dob: this.props.state.primaryDOB,
                  gender: this.props.state.gender,
                  member_id: this.props.state.primaryMemberID270,
                },
              },
            },
          })
          .then(resp => this.afterSuccessfulRegistration(resp))
          .catch(resp => this.afterFailedRegistration(resp));
      } else {
        this.userNotEligible(checkEligibilityRespData);
      }
    } else {
      this.userNotEligible(checkEligibilityRespData);
    }
  }

  userNotEligible(checkEligibilityRespData) {
    var showContinueButton = true;

    var disableRegistration =
      _.get(
        checkEligibilityRespData,
        'eligibility_check.disable_ineligible_member_registration',
        ''
      ) ||
      _.get(
        checkEligibilityRespData,
        'disable_ineligible_member_registration',
        ''
      );
    var eligibilityErrorReason = _.get(
      checkEligibilityRespData,
      'eligibility_check.reason',
      ''
    );

    if (disableRegistration) {
      showContinueButton = false;
    }

    this.setState({
      eligibilityError: true,
      eligibilityErrorText: _.get(checkEligibilityRespData, 'errors.0', ''),
      eligibilityErrorReason: eligibilityErrorReason,
      showContinueButton: showContinueButton,
    });
  }

  submit() {
    if (this.isDTCAffiliation()) {
      return this.signUpDtc();
    } else {
      let patient = this.registrationService.getPatientEligibilityObject(
        this.props.state
      );
      return this.registrationService
        .checkEligibility(patient)
        .then(resp => {
          let checkEligibilityRespData = resp.parsed.data;

          this.setState({
            checkEligibilityRespData,
          });

          if (this.is270Affiliation()) {
            if (
              _.get(
                checkEligibilityRespData,
                'eligibility_check.completed',
                null
              ) === true
            ) {
              return this.signup(checkEligibilityRespData);
            } else if (
              _.get(
                checkEligibilityRespData,
                'eligibility_check.completed',
                null
              ) === false
            ) {
              this.setState({ isLoading: true });
              return this.pollCheckEligibilityStatus(
                checkEligibilityRespData.eligibility_check.token
              );
            }
          } else {
            return this.signup(checkEligibilityRespData);
          }
        })
        .catch(resp => {
          let checkEligibilityRespData = _.get(resp, 'parsed.data', null);
          this.userNotEligible(checkEligibilityRespData);
        });
    }
  }

  signUpDtc() {
    let patient = this.registrationService.getPatientCreateObject(
      this.props.state
    );
    return this.registrationService
      .register({ patient })
      .then(resp => this.afterSuccessfulRegistration(resp))
      .catch(resp => this.afterFailedRegistration(resp));
  }

  afterSuccessfulRegistration(resp) {
    this.registrationService.sendUtmReferral(resp.parsed.data.patient.id);
    this.props.onChange({
      signupRespData: resp.parsed.data,
    });
    this.props.goToStep(4);
  }

  async afterFailedRegistration(resp) {
    let respJson = await resp.json();
    _.each(respJson, (errorMessages, fieldName) => {
      errorMessages.map(errorMessage => {
        this.notificationService.error(errorMessage);
      });
    });
  }

  isDTCAffiliation() {
    return _.get(this.props.state, 'eligibilityBusinessUnitData.type', false) ==
      'DTC'
      ? true
      : false;
  }

  is270Affiliation() {
    return _.get(this.props.state, 'eligibilityBusinessUnitData.type', false) ==
      '270/271'
      ? true
      : false;
  }

  isGeneralDynamics() {
    return _.get(
      this.props.state,
      'eligibilityBusinessUnitData.affiliation_id',
      false
    ) == '270'
      ? true
      : false;
  }

  canSubmit() {
    // check required fields
    let requiredFields = ['eligibilityBusinessUnitData'];

    if (this.is270Affiliation()) {
      requiredFields.push('memberID270');
      requiredFields.push('isDependent');
    }

    if (
      _.get(
        this.props.state,
        'eligibilityBusinessUnitData.sub_plan_affiliations',
        []
      ).length
    ) {
      requiredFields.push('eligibilityBusinessUnit');
    }

    return (
      this.registrationService.checkCanSubmit(
        this.state.validate,
        this.props.state,
        requiredFields
      ) &&
      !this.props.state.isLoading &&
      (_.get(this.props.state, 'hasAffiliatedBenefit', '') == 1
        ? this.state.childSelected
        : true)
    );
  }

  getErrorText(fieldName) {
    if (
      _.get(this.state.validate, fieldName + '.valid', true) ||
      _.isUndefined(_.get(this.state.validate, fieldName + '.valid', undefined))
    )
      return null;
    else
      return _.get(
        this.state.validate,
        fieldName + '.errorMessage',
        'Invalid value'
      );
  }

  onMemberID270Change(e) {
    let value = e.target.value;
    this.props.onChange({ memberID270: value });

    this.setState({
      validate: _.merge(_.cloneDeep(this.state.validate), {
        memberID270: this.validationService.isRequiredValid(value),
      }),
    });
  }

  onPrimaryMemberID270Change(e) {
    let value = e.target.value;
    this.props.onChange({ primaryMemberID270: value });

    this.setState({
      validate: _.merge(_.cloneDeep(this.state.validate), {
        primaryMemberID270: this.validationService.isRequiredValid(value),
      }),
    });
  }

  onDependentChange(e, value) {
    this.props.onChange({ isDependent: value });
  }

  canSubmitPrimary() {
    let errorCount = 0;

    // check errors in the state
    if (_.size(_.get(this.state, 'validate', false))) {
      _.each(this.state.validate, data => {
        if (!data.valid) errorCount++;
      });
    }

    // check required fields
    let requiredFields = [
      'primaryFirstName',
      'primaryLastName',
      'primaryDOB',
      'primaryMemberID270',
      'primaryGender',
      'relationship',
    ];

    _.each(requiredFields, fieldName => {
      let value = _.get(this.props.state, fieldName, '');
      if (!_.toString(value).length) {
        errorCount++;
      }
    });

    return errorCount ? false : true;
  }

  onPrimaryDobChange(e) {
    let value = e.target.value;
    this.props.onChange({ primaryDOB: value });

    this.setState({
      validate: _.merge(_.cloneDeep(this.state.validate), {
        primaryDOB: this.validationService.isValidDate(value),
      }),
    });
  }

  buttonAction() {
    if (_.get(this.props.state, 'isDependent', false)) {
      return <FormattedMessage id="nextButton" />;
    } else {
      if (this.isDTCAffiliation()) {
        return <FormattedMessage id="signupButton" />;
      } else {
        return <FormattedMessage id="verifyButton" />;
      }
    }
  }

  getAutocompleteErrorText() {
    const { intl } = this.props;
    if (
      _.get(this.props.state, 'benefitProviderSearch', '').length > 2 &&
      !this.state.autocompleteDataSource.length &&
      !this.props.state.isLoading
    )
      return intl.formatMessage({ id: 'noMatchFound' });
    return null;
  }

  async affiliationRadioButtonSelected(value, name) {
    this.props.onChange({
      isLoading: true,
      benefitProviderSearch: name,
    });
    if (this.isAffiliated()) {
      this.setState({ affRadioDisabled: true });
    }
    let autocompleteDataSource = await this.benefitProviderSearch(value, true);
    this.onNewRequestBenefitProviderSearch(autocompleteDataSource[0].value);
    if (this.isAffiliated()) {
      this.setState({ childSelected: true });
    } else {
      this.setState({ affRadioSelected: true });
    }
  }

  isAffiliated() {
    return _.size(AFFILIATION_ID) ? true : false;
  }

  render() {
    return (
      <div className="registration-step3 row h-100">
        <div
          className={classNames('loading-wrapper', {
            'loading-wrapper--on-bg': this.state.isLoading,
          })}
        />
        <div
          className={classNames('col col-12 col-md-6 guide-block', {
            'guide-block--doctor-green': !this.state.eligibilityError,
            'guide-block--doctor-red': this.state.eligibilityError,
          })}
        >
          {!this.state.eligibilityError ||
          (!this.state.childSelected &&
            _.get(this.props.state, 'hasAffiliatedBenefit', '') == 1) ? (
            <div>
              <h1>
                {AFFILIATION_DISPLAY_BENEFIT_TEXT || (
                  <span className="affiliation-display-name">
                    <FormattedMessage
                      id="benefitDisplayTitle"
                      values={{ affiliationName: AFFILIATION_DISPLAY_NAME }}
                    />
                  </span>
                )}
              </h1>
            </div>
          ) : null}

          {this.state.eligibilityError &&
          (!this.isAffiliated()
            ? !(_.get(this.state, 'selectableAffiliations', []).length > 0)
            : true) ? (
            <div>
              <h4>
                <FormattedMessage id="oops" />
              </h4>

              {this.state.eligibilityErrorReason.length > 0 ? (
                <div>
                  <p>
                    {this.state.eligibilityErrorReason}
                    {'\n'}
                  </p>
                  {this.state.showContinueButton && (
                    <p>
                      If you click on "Continue" below, MDLIVE will allow you to
                      continue to register, but your credit card will be
                      authorized for the full consult amount until we can obtain
                      the information and adjust your final payment due
                      accordingly.
                    </p>
                  )}
                </div>
              ) : (
                <div>
                  <p hidden={this.state.eligibilityErrorText.length > 0}>
                    <FormattedMessage id="eligibilityError.Text1" />
                    <br />
                    <br />
                    <p hidden={this.state.showContinueButton}>
                      <FormattedMessage id="eligibilityError.Text2" />
                    </p>
                  </p>

                  {this.state.eligibilityErrorText.length > 1 ? (
                    <p>
                      {this.state.eligibilityErrorText}
                      {'\n'}
                      <FormattedMessage id="eligibilityError.Text3" />
                    </p>
                  ) : null}

                  <br />
                  <br />

                  <p>
                    <FormattedMessage id="eligibilityError.pleaseCall" />:{' '}
                    <b>{AFFILIATION_PHONE_NUMBER}</b>
                  </p>
                </div>
              )}
            </div>
          ) : null}

          {this.isAffiliated() &&
          !this.state.childSelected &&
          _.get(this.props.state, 'hasAffiliatedBenefit', '') == 1 ? (
            <div>
              <p>
                <strong>
                  <FormattedMessage id="multipleBenefitProviders" />
                </strong>
              </p>
            </div>
          ) : null}
        </div>

        {!this.state.childSelected &&
        (this.isAffiliated()
          ? _.get(this.props.state, 'hasAffiliatedBenefit', '') == 1
          : _.get(this.state, 'selectableAffiliations', []).length > 0)
          ? this.showAffiliationList()
          : !this.state.showPrimary
          ? this.showYourInformation()
          : this.showPrimaryInformation()}
      </div>
    );
  }

  showAffiliationList() {
    return (
      <div className="col col-12 col-md-6 content-block h-100">
        {!this.isAffiliated() &&
        _.get(this.props.state, 'hasAffiliatedBenefit', '') != 1 ? (
          <div className="form-header">
            <p>
              <strong>
                <FormattedMessage id="multipleBenefitProviders" />
              </strong>
            </p>
          </div>
        ) : !this.state.childSelected && this.isAffiliated() ? (
          <div className="form-header">
            <h3>
              <FormattedMessage id="subtitle" />
            </h3>
          </div>
        ) : null}
        {
          <div className="form-content container-fluid flex-grow h-100 p-0 m-0">
            <div className="form-group">
              <RadioButtonGroup
                name="affiliation-options"
                className="radios-block"
                onChange={(e, value) =>
                  this.affiliationRadioButtonSelected(value, e.target.title)
                }
              >
                {_.get(this.state, 'selectableAffiliations', []).map(
                  (item, index) => {
                    return (
                      <RadioButton
                        label={item[1]}
                        value={item[0]}
                        id={'radio-button'}
                        title={item[1]}
                        key={index + 1}
                        disabled={this.state.affRadioDisabled}
                      />
                    );
                  }
                )}
              </RadioButtonGroup>
            </div>
          </div>
        }

        <div className="container-fluid form-footer p-0">
          {_.size(CHILD_AFFILIATIONS) > 0 ? (
            <div className="float-left back">
              <FlatButton
                label={
                  <FormattedMessage
                    id="backButton"
                    values={{ backArrow: '<' }}
                  />
                }
                onClick={() => {
                  this.props.goToStep(2);
                }}
                id="back"
              />
            </div>
          ) : null}

          <div className="float-right">
            <RaisedButton
              label={<FormattedMessage id="continueButton" />}
              backgroundColor="#3DD69F"
              backgroundColor="var(--affiliation-registration-next-button-color)"
              labelColor="#FFFFFF"
              onClick={() => this.submit()}
              className={classNames('raised-button--rounded', {
                disabled: !this.canSubmit(),
              })}
              disabled={!this.state.affRadioSelected}
            />
          </div>
        </div>
      </div>
    );
  }

  showYourInformation() {
    const { intl } = this.props;
    return (
      <div className="col col-12 col-md-6 content-block h-100">
        {this.isAffiliated() ? (
          <h3>
            <FormattedMessage id="subtitle" />
          </h3>
        ) : (
          <h3 className="get-started">
            <FormattedMessage id="getStarted" />
          </h3>
        )}

        {(AFFILIATION.length > 0
          ? typeof this.props.state.benefitProviderSearch !== 'undefined'
          : true) &&
        (this.state.childSelected ||
          _.get(this.props.state, 'hasAffiliatedBenefit', '') == 0 ||
          !(_.get(this.state, 'selectableAffiliations', []).length > 0)) ? (
          <div className="form-content container-fluid flex-grow h-100 p-0 m-0">
            <div className="form-group">
              <AutoComplete
                id="benefit-provider-search"
                label={intl.formatMessage({ id: 'benefitProviderSearch' })}
                suggestions={this.state.autocompleteDataSource}
                onInputValueChange={query =>
                  this.onChangeBenefitProviderSearch(query)
                }
                onSelect={selectedItem =>
                  this.onBenefitProviderSelect(selectedItem)
                }
                disabled={_.size(AFFILIATION) > 0}
                helperText={this.getAutocompleteErrorText()}
                error={Boolean(this.getAutocompleteErrorText())}
                initialInputValue={this.props.state.benefitProviderSearch}
              />
              <InfoOutline
                className="affiliation-search-tooltip-btn"
                onClick={() =>
                  this.setState({
                    isSearchTooltipVisible: !this.state.isSearchTooltipVisible,
                  })
                }
                style={{ width: 18, height: 18, color: '#40AD86' }}
              />

              {this.state.isSearchTooltipVisible && (
                <div className="tooltipText">
                  <FormattedMessage id="benefitProviderTooltip" />
                </div>
              )}
            </div>

            {this.isGeneralDynamics() ? (
              <div className="form-group pt-3">
                <FormControl fullWidth>
                  <InputLabel id="business-unit-label">
                    <FormattedMessage id="businessUnit" />
                  </InputLabel>

                  <Select
                    label-id="business-unit-label"
                    value={this.props.state.eligibilityBusinessUnit || ''}
                    onChange={event =>
                      this.props.onChange({
                        eligibilityBusinessUnit: event.target.value,
                      })
                    }
                    id="business-unit"
                  >
                    {_.get(
                      this.props.state,
                      'eligibilityBusinessUnitData.business_units',
                      []
                    ).map((businessUnit, k) => {
                      return (
                        <MenuItem key={k} value={businessUnit}>
                          {businessUnit.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>

                {_.size(
                  _.get(
                    this.props.state,
                    'eligibilityBusinessUnit.insurance_plans',
                    []
                  )
                ) ? (
                  <div className="pt-2">
                    <FormControl fullWidth>
                      <InputLabel id="insurance-plan-label">
                        <FormattedMessage id="insurancePlan" />
                      </InputLabel>

                      <Select
                        label-id="insurance-plan-label"
                        value={this.props.state.eligibilityInsurancePlan || ''}
                        onChange={event =>
                          this.props.onChange({
                            eligibilityInsurancePlan: event.target.value,
                          })
                        }
                        id="insurance-plan"
                      >
                        {_.get(
                          this.props.state,
                          'eligibilityBusinessUnit.insurance_plans',
                          []
                        ).map(insurancePlan => {
                          return (
                            <MenuItem
                              key={insurancePlan.id}
                              value={insurancePlan.id}
                            >
                              {insurancePlan.name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </div>
                ) : null}
              </div>
            ) : (
              <div className="form-group pt-3">
                {_.size(
                  _.get(
                    this.props.state,
                    'eligibilityBusinessUnitData.sub_plan_affiliations',
                    []
                  )
                ) ? (
                  <FormControl fullWidth>
                    <InputLabel id="business-unit-label">
                      <FormattedMessage id="businessUnit" />
                    </InputLabel>

                    <Select
                      label-id="business-unit-label"
                      value={this.props.state.eligibilityBusinessUnit || ''}
                      onChange={event =>
                        this.props.onChange({
                          eligibilityBusinessUnit: event.target.value,
                        })
                      }
                      id="business-unit"
                    >
                      {_.get(
                        this.props.state,
                        'eligibilityBusinessUnitData.sub_plan_affiliations',
                        []
                      ).map((subplanAffiliation, k) => {
                        return (
                          <MenuItem key={k} value={subplanAffiliation}>
                            {subplanAffiliation.description}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                ) : null}
              </div>
            )}

            {this.is270Affiliation() ? (
              <div>
                <div className="form-group customer-id-wrapper">
                  <TextField
                    fullWidth={true}
                    floatingLabelText={
                      <FormattedMessage id="medicalInsuranceID" />
                    }
                    hintText={this.props.state.insuranceLabel || ''}
                    hintStyle={{
                      textOverflow: 'ellipsis',
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      maxWidth: '90%',
                      fontSize: 11,
                    }}
                    floatingLabelFixed={
                      this.props.state.insuranceLabel ? true : false
                    }
                    errorText={this.getErrorText('memberID270')}
                    value={this.props.state.memberID270 || ''}
                    onChange={e => this.onMemberID270Change(e)}
                    errorStyle={errorStyle}
                    floatingLabelStyle={textStyle}
                    underlineStyle={underlineStyle}
                    id="insurance-id"
                  />

                  {this.props.state.tooltipImage ? (
                    <InfoOutline
                      className="affiliation-tooltip-btn"
                      onClick={() =>
                        this.setState({
                          isTooltipVisible: !this.state.isTooltipVisible,
                        })
                      }
                      style={{ width: 18, height: 18, color: '#40AD86' }}
                    />
                  ) : null}

                  {this.state.isTooltipVisible ? (
                    <div className="affiliation-tooltip">
                      <img src={this.props.state.tooltipImage} alt="" />
                    </div>
                  ) : null}
                </div>

                {this.state.isTooltipVisible ? (
                  <div
                    className="affiliation-tooltip-overlay"
                    onClick={() =>
                      this.setState({
                        isTooltipVisible: !this.state.isTooltipVisible,
                      })
                    }
                  />
                ) : null}

                <div className="form-group">
                  <hr className="d-sm-none d-md-block" />
                  <p className="mt-3">
                    <FormattedMessage id="isInsuredAsDependent" />
                  </p>
                  <RadioButtonGroup
                    name="isDependent"
                    className={classNames('inline-radios-block')}
                    valueSelected={_.get(this.props.state, 'isDependent', '')}
                    onChange={(e, value) => this.onDependentChange(e, value)}
                  >
                    <RadioButton
                      label={<FormattedMessage id="yesButton" />}
                      value={1}
                      id="yes"
                    />
                    <RadioButton
                      label={<FormattedMessage id="noButton" />}
                      value={0}
                      id="no"
                    />
                  </RadioButtonGroup>
                </div>
              </div>
            ) : null}
          </div>
        ) : null}

        <div className="container-fluid form-footer p-0">
          <div className="float-left back">
            <FlatButton
              label={
                <FormattedMessage id="backButton" values={{ backArrow: '<' }} />
              }
              onClick={() => this.props.goToStep(2)}
              id="back"
            />
          </div>
          {this.state.showContinueButton ? (
            <div className="float-right">
              <RaisedButton
                label={<FormattedMessage id="continueButton" />}
                backgroundColor="#3DD69F"
                backgroundColor="var(--affiliation-registration-next-button-color)"
                labelColor="#FFFFFF"
                onClick={() => {
                  this.setState({ continueRegistration: true });
                  this.submit();
                }}
                className={classNames('raised-button--rounded', {
                  disabled: !this.canSubmit(),
                })}
              />
            </div>
          ) : null}

          <div className="float-right">
            <RaisedButton
              label={this.buttonAction()}
              backgroundColor="#3DD69F"
              backgroundColor="var(--affiliation-registration-next-button-color)"
              labelColor="#FFFFFF"
              onClick={() => {
                this.props.state.isDependent == 1
                  ? this.setState({ showPrimary: true })
                  : this.submit();
              }}
              className={classNames('raised-button--rounded', {
                disabled: !this.canSubmit(),
              })}
              disabled={!this.canSubmit()}
            />
          </div>
        </div>
      </div>
    );
  }

  showPrimaryInformation() {
    const { intl } = this.props;
    return (
      <div className="col col-12 col-md-6 content-block h-100">
        <h3>
          <FormattedMessage id="primaryPolicyHolder" />
        </h3>
        <div className="form-content container-fluid flex-grow h-100 p-0 m-0">
          <div className="form-group">
            <TextField
              fullWidth={true}
              floatingLabelText={<FormattedMessage id="firstName" />}
              value={this.props.state.primaryFirstName || ''}
              onChange={e =>
                this.props.onChange({ primaryFirstName: e.target.value })
              }
              errorStyle={errorStyle}
              floatingLabelStyle={textStyle}
              underlineStyle={underlineStyle}
              id="first-name"
            />
          </div>
          <div className="form-group">
            <TextField
              fullWidth={true}
              floatingLabelText={<FormattedMessage id="lastName" />}
              value={this.props.state.primaryLastName || ''}
              onChange={e =>
                this.props.onChange({ primaryLastName: e.target.value })
              }
              errorStyle={errorStyle}
              floatingLabelStyle={textStyle}
              underlineStyle={underlineStyle}
              id="last-name"
            />
          </div>

          <div className="form-group">
            <MaskedTextField
              fullWidth={true}
              floatingLabelText={<FormattedMessage id="dateOfBirth" />}
              floatingLabelFixed={true}
              placeholder="mm/dd/yyyy"
              errorText={this.getErrorText('primaryDOB')}
              value={this.props.state.primaryDOB || ''}
              onChange={e => this.onPrimaryDobChange(e)}
              errorStyle={errorStyle}
              floatingLabelStyle={textStyle}
              underlineStyle={underlineStyle}
              mask="99/99/9999"
              id="dob"
            />
          </div>

          <div className="form-group pb-2 customer-id-wrapper">
            <TextField
              fullWidth={true}
              floatingLabelText={<FormattedMessage id="primaryInsuranceID" />}
              hintText={this.props.state.insuranceLabel || ''}
              hintStyle={{
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                maxWidth: '90%',
                fontSize: 11,
              }}
              floatingLabelFixed={
                this.props.state.insuranceLabel ? true : false
              }
              errorText={this.getErrorText('primaryMemberID270')}
              value={this.props.state.primaryMemberID270 || ''}
              onChange={e => this.onPrimaryMemberID270Change(e)}
              errorStyle={errorStyle}
              floatingLabelStyle={textStyle}
              underlineStyle={underlineStyle}
              id="primary-member-id"
            />

            {this.props.state.tooltipImage ? (
              <InfoOutline
                className="affiliation-tooltip-btn"
                onClick={() =>
                  this.setState({
                    isTooltipVisible: !this.state.isTooltipVisible,
                  })
                }
                style={{ width: 18, height: 18, color: '#40AD86' }}
              />
            ) : null}

            {this.state.isTooltipVisible ? (
              <div className="affiliation-tooltip">
                <img src={this.props.state.tooltipImage} alt="" />
              </div>
            ) : null}
          </div>

          {this.state.isTooltipVisible ? (
            <div
              className="affiliation-tooltip-overlay"
              onClick={() =>
                this.setState({
                  isTooltipVisible: !this.state.isTooltipVisible,
                })
              }
            />
          ) : null}

          <div className="form-group pb-3">
            <FormControl fullWidth>
              <InputLabel id="primary-gender-label">
                <FormattedMessage id="gender" />
              </InputLabel>

              <Select
                label-id="primary-gender-label"
                value={this.props.state.primaryGender || ''}
                onChange={event =>
                  this.props.onChange({ primaryGender: event.target.value })
                }
                id="primary-gender"
              >
                <MenuItem value="Male">
                  <FormattedMessage id="male" />
                </MenuItem>
                <MenuItem value="Female">
                  <FormattedMessage id="female" />
                </MenuItem>
                <MenuItem value="Non-binary">
                  <FormattedMessage id="nonBinary" />
                </MenuItem>
              </Select>
            </FormControl>
          </div>

          <div className="form-group">
            <FormControl fullWidth>
              <InputLabel id="policy-holder-relationship-label">
                <FormattedMessage id="relationshipToPolicyHolder" />
              </InputLabel>

              <Select
                label-id="policy-holder-relationship-label"
                value={this.props.state.relationship || ''}
                onChange={event =>
                  this.props.onChange({ relationship: event.target.value })
                }
                id="policy-holder-relationship"
              >
                <MenuItem value="01">
                  <FormattedMessage id="spouse" />
                </MenuItem>
                <MenuItem value="19">
                  <FormattedMessage id="child" />
                </MenuItem>
                <MenuItem value="34">
                  <FormattedMessage id="otherAdult" />
                </MenuItem>
              </Select>
            </FormControl>
          </div>
        </div>
        <div className="container-fluid form-footer">
          <div className="float-left back">
            <FlatButton
              label={
                <FormattedMessage id="backButton" values={{ backArrow: '<' }} />
              }
              onClick={() => {
                this.setState({ showPrimary: false });
              }}
              id="back"
            />
          </div>
          {this.state.showContinueButton ? (
            <div className="float-right">
              <RaisedButton
                label={<FormattedMessage id="continueButton" />}
                backgroundColor="#3DD69F"
                backgroundColor="var(--affiliation-registration-next-button-color)"
                labelColor="#FFFFFF"
                onClick={() => {
                  this.setState({ continueRegistration: true });
                  this.submit();
                }}
                className={classNames('raised-button--rounded', {
                  disabled: !this.canSubmit(),
                })}
              />
            </div>
          ) : null}
          <div className="float-right">
            <RaisedButton
              label={<FormattedMessage id="verifyButton" />}
              backgroundColor="#3DD69F"
              backgroundColor="var(--affiliation-registration-next-button-color)"
              labelColor="#FFFFFF"
              onClick={() => this.submit()}
              className={classNames('raised-button--rounded', {
                disabled: !this.canSubmitPrimary(),
              })}
              disabled={!this.canSubmitPrimary()}
              id="verify"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(RegistrationStep3);



// WEBPACK FOOTER //
// ./registration-react/components/registration-step3.js